var map = {
	"./assets/about/about.hero.asset.jpg": "da43",
	"./assets/brochure/Brochure-Puroak-EN.asset.pdf": "b1c9",
	"./assets/brochure/Brochure-Puroak-ES.asset.pdf": "8cfa",
	"./assets/brochure/Brochure-Puroak-FR.asset.pdf": "f306",
	"./assets/checkout/checkout.hero.asset.jpg": "cdd0",
	"./assets/contact/contact.hero.asset.jpg": "114b",
	"./assets/groove.asset.svg": "9c7e",
	"./assets/heating/heating.hero.asset.jpg": "cd23",
	"./assets/heating/heating.type.01.asset.jpg": "577e",
	"./assets/heating/heating.type.02.asset.jpg": "0a63",
	"./assets/heating/heating.type.03.asset.jpg": "c65d",
	"./assets/heating/labels/heating-type-01-label-en.asset.svg": "35cf",
	"./assets/heating/labels/heating-type-01-label-es.asset.svg": "cc6b",
	"./assets/heating/labels/heating-type-01-label-fr.asset.svg": "ce8b",
	"./assets/heating/labels/heating-type-02-label-en.asset.svg": "9b79",
	"./assets/heating/labels/heating-type-02-label-es.asset.svg": "b7f7",
	"./assets/heating/labels/heating-type-02-label-fr.asset.svg": "9b1d",
	"./assets/heating/labels/heating-type-03-label-en.asset.svg": "a8fc",
	"./assets/heating/labels/heating-type-03-label-es.asset.svg": "f753",
	"./assets/heating/labels/heating-type-03-label-fr.asset.svg": "44b5",
	"./assets/homepage/homepage.commitment.01.asset.jpg": "090f",
	"./assets/homepage/homepage.commitment.02.asset.jpg": "0754",
	"./assets/homepage/homepage.commitment.03.asset.jpg": "2028",
	"./assets/homepage/homepage.commitment.04.asset.jpg": "c26b",
	"./assets/homepage/homepage.hero.asset.jpg": "644e",
	"./assets/homepage/homepage.product.01.asset.jpg": "58b6",
	"./assets/homepage/homepage.product.02.asset.jpg": "518d",
	"./assets/homepage/homepage.product.03.asset.jpg": "381f",
	"./assets/homepage/homepage.product.04.asset.jpg": "f0cd",
	"./assets/homepage/homepage.product.05.asset.jpg": "2617",
	"./assets/homepage/homepage.product.06.asset.jpg": "12c3",
	"./assets/homepage/homepage.product.07.asset.jpg": "e0ea",
	"./assets/homepage/homepage.section2.asset.jpg": "c3c2",
	"./assets/homepage/homepage.section4.01.asset.jpg": "e01ab",
	"./assets/homepage/homepage.section4.02.asset.jpg": "5284",
	"./assets/homepage/homepage.section4.03.asset.jpg": "59de",
	"./assets/homepage/homepage.section4.04.asset.jpg": "6556",
	"./assets/labels/label.puroak.01.asset.png": "ec3d",
	"./assets/labels/label.puroak.02.asset.png": "d753",
	"./assets/labels/label.puroak.03.asset.png": "7ca3",
	"./assets/labels/label.puroak.04.asset.png": "9677",
	"./assets/labels/label.puroak.05.asset.png": "e094",
	"./assets/labels/label.puroak.06.asset.png": "d8e6",
	"./assets/labels/puroak.icon.assurance.asset.svg": "3874",
	"./assets/labels/puroak.icon.bdf.asset.svg": "adf9",
	"./assets/labels/puroak.icon.leaf.asset.svg": "7718",
	"./assets/labels/puroak.icon.logSplitter.asset.svg": "e0e2",
	"./assets/labels/puroak.icon.magnifyingGlass.asset.svg": "211a",
	"./assets/labels/puroak.icon.pefc.asset.svg": "e56f",
	"./assets/logo-puroak-mobile.asset.png": "8b0a",
	"./assets/logo-puroak-white.asset.png": "0927",
	"./assets/logo-puroak-white.asset.svg": "95e4",
	"./assets/logo-puroak.asset.png": "45ac",
	"./assets/logo-puroak.asset.svg": "9b31",
	"./assets/markers/m1.asset.png": "3297",
	"./assets/markers/m2.asset.png": "8b22",
	"./assets/markers/m3.asset.png": "bea0",
	"./assets/markers/m4.asset.png": "226b",
	"./assets/markers/m5.asset.png": "6f5a",
	"./assets/palette/Palette-Puroak-EN.asset.svg": "9f5c",
	"./assets/palette/Palette-Puroak-ES.asset.svg": "35c8",
	"./assets/palette/Palette-Puroak-FR.asset.svg": "2e75",
	"./assets/placeholder.asset.jpg": "1afd",
	"./assets/product_sheets/Fiche-EN-Produit-Puroak-Block-24.asset.pdf": "9b90",
	"./assets/product_sheets/Fiche-EN-Produit-Puroak-Block-7.asset.pdf": "5020",
	"./assets/product_sheets/Fiche-EN-Produit-Puroak-Copeaux.asset.pdf": "16cf",
	"./assets/product_sheets/Fiche-EN-Produit-Puroak-Granulés.asset.pdf": "c2d8",
	"./assets/product_sheets/Fiche-EN-Produit-Puroak-Mini-Staves.asset.pdf": "a5b8",
	"./assets/product_sheets/Fiche-EN-Produit-Puroak-Stave-24.asset.pdf": "1e49",
	"./assets/product_sheets/Fiche-EN-Produit-Puroak-Stave-7.asset.pdf": "6595",
	"./assets/product_sheets/Fiche-ES-Produit-Puroak-Block-24.asset.pdf": "9080",
	"./assets/product_sheets/Fiche-ES-Produit-Puroak-Block-7.asset.pdf": "0164",
	"./assets/product_sheets/Fiche-ES-Produit-Puroak-Copeaux.asset.pdf": "5b07",
	"./assets/product_sheets/Fiche-ES-Produit-Puroak-Granulés.asset.pdf": "ad3d",
	"./assets/product_sheets/Fiche-ES-Produit-Puroak-Mini-Staves.asset.pdf": "d7d6",
	"./assets/product_sheets/Fiche-ES-Produit-Puroak-Stave-24.asset.pdf": "6a11",
	"./assets/product_sheets/Fiche-ES-Produit-Puroak-Stave-7.asset.pdf": "5858",
	"./assets/product_sheets/Fiche-FR-Produit-Puroak-Block-24.asset.pdf": "6e16",
	"./assets/product_sheets/Fiche-FR-Produit-Puroak-Block-7.asset.pdf": "30fd",
	"./assets/product_sheets/Fiche-FR-Produit-Puroak-Copeaux.asset.pdf": "9007",
	"./assets/product_sheets/Fiche-FR-Produit-Puroak-Granulés.asset.pdf": "a2ef",
	"./assets/product_sheets/Fiche-FR-Produit-Puroak-Mini-Staves.asset.pdf": "1b19",
	"./assets/product_sheets/Fiche-FR-Produit-Puroak-Stave-24.asset.pdf": "760f",
	"./assets/product_sheets/Fiche-FR-Produit-Puroak-Stave-7.asset.pdf": "260d",
	"./assets/products/products.hero.asset.jpg": "a079",
	"./assets/puroak-range-products.asset.png": "3389",
	"./assets/video-placeholder.asset.mp4": "ae50",
	"./components/organisms/priceRequest.runtime.ts": "2518",
	"./components/organisms/quote.runtime.ts": "4633",
	"./modules/cartProductsCounter.runtime.ts": "f44f",
	"./modules/contact.runtime.ts": "1079",
	"./modules/homeVideo.runtime.ts": "df7b",
	"./modules/inputNumber.runtime.ts": "e26a",
	"./modules/map.runtime.ts": "0d46",
	"./modules/modal.runtime.ts": "107b",
	"./modules/navigation.runtime.ts": "6369",
	"./modules/select.runtime.ts": "f0b1",
	"./modules/slider.runtime.ts": "b735",
	"./styles/atomic/pages/checkout.style.scss": "96d8",
	"./styles/atomic/pages/contact.style.scss": "061d",
	"./styles/atomic/pages/index.style.scss": "1b8f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9ff8";